import { NgModule } from "@angular/core";
import { SharedModule } from '../shared/shared.module';
import { AdminRouting } from "./admin.routes";
import { HomeComponent } from "./home/home.component";
//import { AddAdminComponent } from './add-admin/add-admin.component';
import { OvedDetailsAdminComponent } from './oved-details-admin/oved-details-admin.component';
import { AdminActivitiesComponent } from './admin-activities/admin-activities.component';
import { PeiluyotAdminOvedDetailsComponent } from './peiluyot-admin/peiluyot-admin-oved-details/peiluyot-admin-oved-details.component';
import { NofeshAdminHomeComponent } from './nofesh-admin/nofesh-admin-home/nofesh-admin-home.component';
import { NofshonimAdminHomeComponent } from './nofshonim-admin/nofshonim-admin-home/nofshonim-admin-home.component';
import { MatanotAdminOvedDetailsComponent } from './matanot-admin/matanot-admin-oved-details/matanot-admin-oved-details.component';
import { MatanotAdminHomeComponent } from './matanot-admin/matanot-admin-home/matanot-admin-home.component';
import { PeiluyotAdminHomeComponent } from './peiluyot-admin/peiluyot-admin-home/peiluyot-admin-home.component';
import {MatNativeDateModule, MatDatepickerModule, MatFormFieldModule, MatInputModule, MatExpansionModule, MatMenuModule, MatIconModule, MatTooltipModule, MatButtonModule,} from '@angular/material';
import {MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS} from '@angular/material/dialog';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ProvidersFeature } from "@angular/core/src/render3";
import { OvedHomeComponent } from './nofesh-nofshonim-oved-admin/oved-home/oved-home.component';
import { OvedDetailsComponent } from './nofesh-nofshonim-oved-admin/oved-details/oved-details.component';
import { NofshonimCharigimComponent } from './nofshonim-admin/nofshonim-charigim/nofshonim-charigim.component';
import { ConfirmDialogComponent } from "app/shared/dialog/confirm-dialog/confirm-dialog.component";
import { SinglesUniteComponent } from './nofesh-admin/singles-unite/singles-unite.component';
import { NofeshAdminReservationsComponent } from './nofesh-admin/nofesh-admin-reservations/nofesh-admin-reservations.component';
import { NofshonimAdminReservationsComponent } from './nofshonim-admin/nofshonim-admin-reservations/nofshonim-admin-reservations.component';
import { HamtanaOrBitulComponent } from './nofesh-admin/hamtana-or-bitul/hamtana-or-bitul.component';
import { HamtanaOrBitulNofshonComponent } from "./nofshonim-admin/hamtana-or-bitul/hamtana-or-bitul.component";
import { UpdatePaymentComponent } from "./nofshonim-admin/update-payment/update-payment.component";
import { ChangeNofshonComponent } from './nofshonim-admin/change-nofshon/change-nofshon.component';
import { ChangeNofeshComponent } from './nofesh-admin/change-nofesh/change-nofesh.component';
import { UpdateNofeshPaymentComponent } from "./nofesh-admin/update-nofesh-payment/update-nofesh-payment.component";
import { AddNilveComponent } from './nofesh-admin/add-nilve/add-nilve.component';
import { ChangeNofeshMultipleComponent } from './nofesh-admin/change-nofesh-multiple/change-nofesh-multiple.component';
import { NofeshModule } from "app/nofesh/nofesh.module";
import { HamtanaBitulMultipleComponent } from './nofesh-admin/hamtana-bitul-multiple/hamtana-bitul-multiple.component';
import { HamtanaBitulNofshonMultipleComponent } from "./nofshonim-admin/hamtana-bitul-nofshon-multiple/hamtana-bitul-nofshon-multiple.component";
import { FindOvedComponent } from './nofesh-nofshonim-oved-admin/find-oved/find-oved.component';
import { AddNofeshMeurganComponent } from './nofesh-admin/add-nofesh-meurgan/add-nofesh-meurgan.component';
import { NofeshSummaryComponent } from './charts/nofesh-charts/nofesh-summary/nofesh-summary.component';
import { NofshonimSummaryComponent } from './nofshonim-admin/reports/nofshonim-summary/nofshonim-summary.component';
import { NofshonNirshamimComponent } from './nofshonim-admin/reports/nofshon-nirshamim/nofshon-nirshamim.component';
import { NofshonMamtinimComponent } from './nofshonim-admin/reports/nofshon-mamtinim/nofshon-mamtinim.component';
import { PasswordProtectionComponent } from './export-to-excel/password-protection/password-protection.component';
import { ExportToExcelComponent } from "./export-to-excel/export-to-excel/export-to-excel.component";
import { PasswordProtectionService } from "./export-to-excel/password-protection/password-protection.service";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { BrowserModule } from "@angular/platform-browser";
import { AddNofeshComponent } from './nofesh-admin/add-nofesh/add-nofesh.component';


//import { UpdatePaymentComponent } from './nofesh-nofshonim-oved-admin/update-payment/update-payment.component';



@NgModule({
    imports: [
        AdminRouting,
        SharedModule,
        NofeshModule,
        ReactiveFormsModule,
        FormsModule,
        HttpClientModule,
        BrowserModule,
        BrowserAnimationsModule,
        MatNativeDateModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        MatExpansionModule,
        MatMenuModule,
        MatIconModule,
        MatDialogModule,
        MatTooltipModule
    ],
    declarations: [
        HomeComponent,
        //AddAdminComponent,
        OvedDetailsAdminComponent, 
        AdminActivitiesComponent,
        PeiluyotAdminHomeComponent,
        PeiluyotAdminOvedDetailsComponent, 
        NofeshAdminHomeComponent, 
        NofshonimAdminHomeComponent, 
        MatanotAdminOvedDetailsComponent, 
        MatanotAdminHomeComponent,
        OvedHomeComponent,
        OvedDetailsComponent,
        NofshonimCharigimComponent,
        SinglesUniteComponent,
        NofeshAdminReservationsComponent,
        NofshonimAdminReservationsComponent,
        HamtanaOrBitulComponent,
        HamtanaOrBitulNofshonComponent,
        //UpdatePaymentComponent
        UpdatePaymentComponent,
        ChangeNofshonComponent,
        ChangeNofeshComponent,
        UpdateNofeshPaymentComponent,
        AddNilveComponent,
        ChangeNofeshMultipleComponent,
        HamtanaBitulMultipleComponent,
        HamtanaBitulNofshonMultipleComponent,
        FindOvedComponent,
        AddNofeshMeurganComponent,
        NofeshSummaryComponent,
        NofshonimSummaryComponent,
        NofshonNirshamimComponent,
        NofshonMamtinimComponent,
        ExportToExcelComponent,
        PasswordProtectionComponent,
        AddNofeshComponent
    ],
    providers:[
        PasswordProtectionService
    ],
    entryComponents: [
        PasswordProtectionComponent
    ]
})

export class AdminModule { }
